module.exports = __webpack_public_path__ + "img/indexbanner.2008a77a.jpg";